export enum TimeFrames {
    D1 = "1d",
    D3 = "3d",
    W1 = "1w",
    W2 = "2w",
    MON1 = "1M",
}